/**
 * Tab Eventos — linha do tempo do projeto.
 */

import React, { useEffect, useState } from 'react';
import { adminInovacaoAPI } from '../../../services/inovacaoAPI';

export default function EventosWS({ projeto }) {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminInovacaoAPI.eventosDaEntidade('projeto', projeto.id)
      .then(setEventos)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [projeto.id]);

  if (loading) return <div style={cardStyle}>Carregando…</div>;

  return (
    <div style={cardStyle}>
      <h3 style={{ margin: '0 0 16px', color: '#2c3e50' }}>
        Linha do tempo ({eventos.length} evento(s))
      </h3>
      {eventos.length === 0 ? (
        <p style={{ color: '#bdc3c7' }}>Nenhum evento registrado.</p>
      ) : (
        <div style={{ position: 'relative', paddingLeft: 24 }}>
          <div style={{
            position: 'absolute', left: 8, top: 8, bottom: 8,
            width: 2, background: '#ecf0f1',
          }} />
          {eventos.map((e, idx) => (
            <div key={e.id} style={{ position: 'relative', marginBottom: 16 }}>
              <div style={{
                position: 'absolute', left: -20, top: 6,
                width: 12, height: 12, borderRadius: 6,
                background: e.processado_em ? 'var(--brand, #20a490)' : '#f39c12',
                border: '2px solid #fff', boxShadow: '0 0 0 2px #ecf0f1',
              }} />
              <div style={{ fontSize: '0.9rem' }}>
                <code style={{ background: '#f8f9fa', padding: '2px 6px', borderRadius: 3,
                               color: 'var(--brand, #20a490)', fontSize: '0.8rem' }}>{e.tipo}</code>
                {e.ator && <span style={{ color: '#7f8c8d' }}> por <b>{e.ator.nome}</b></span>}
              </div>
              <div style={{ fontSize: '0.75rem', color: '#95a5a6', marginTop: 2 }}>
                {new Date(e.ocorrido_em).toLocaleString('pt-BR')}
              </div>
              {e.payload && Object.keys(e.payload).length > 0 && (
                <details style={{ marginTop: 4 }}>
                  <summary style={{ cursor: 'pointer', fontSize: '0.75rem', color: '#7f8c8d' }}>payload</summary>
                  <pre style={{ fontSize: '0.72rem', background: '#f8f9fa', padding: 8, borderRadius: 4,
                                overflow: 'auto', margin: '4px 0 0' }}>
                    {JSON.stringify(e.payload, null, 2)}
                  </pre>
                </details>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const cardStyle = { background: '#fff', borderRadius: 12, padding: 24,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
